class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    // Hover-to-open only on desktop devices with a real mouse; touch/keyboard keep click-to-toggle.
    this.hoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  onSummaryClick(event) {
    event.preventDefault();

    if (this.mainDetailsToggle.classList.contains('is-open')) {
      // With a mouse the menu follows hover, so a click shouldn't close it under the cursor.
      if (this.hoverQuery.matches && event.detail > 0) {
        this.summary.setAttribute('aria-expanded', true);
        return;
      }
      this.close();
    } else {
      this.open();
    }
  }

  onMouseEnter() {
    if (!this.hoverQuery.matches) return;
    clearTimeout(this.closeTimer);
    clearTimeout(this.openTimer);

    // Small intent delay so sweeping the cursor across the nav doesn't flash menus,
    // but switch instantly when another menu is already open.
    const anotherOpen = document.querySelector('header-menu > details.is-open');
    if (anotherOpen && anotherOpen !== this.mainDetailsToggle) {
      this.open();
    } else {
      this.openTimer = setTimeout(() => this.open(), 80);
    }
  }

  onMouseLeave() {
    if (!this.hoverQuery.matches) return;
    clearTimeout(this.openTimer);
    // Grace period lets the cursor cross the gap between the link and the panel.
    this.closeTimer = setTimeout(() => this.close(), 200);
  }

  open() {
    clearTimeout(this.openTimer);
    clearTimeout(this.closeTimer);
    clearTimeout(this.hideTimer);

    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) menu.close();
    });

    const details = this.mainDetailsToggle;
    details.classList.remove('is-closing');
    if (!details.open) {
      details.open = true;
      // Force a reflow so the transition starts from the hidden state.
      this.content.offsetHeight;
    }
    details.classList.add('is-open');
    this.summary.setAttribute('aria-expanded', true);
  }

  close() {
    clearTimeout(this.openTimer);
    clearTimeout(this.closeTimer);

    const details = this.mainDetailsToggle;
    if (!details.open || details.classList.contains('is-closing')) return;

    details.classList.remove('is-open');
    details.classList.add('is-closing');
    this.summary.setAttribute('aria-expanded', false);

    clearTimeout(this.hideTimer);
    this.hideTimer = setTimeout(() => {
      details.classList.remove('is-closing');
      details.open = false;
    }, this.getTransitionDuration());
  }

  getTransitionDuration() {
    const duration = window.getComputedStyle(this.content).transitionDuration.split(',')[0];
    return duration.endsWith('ms') ? parseFloat(duration) : parseFloat(duration) * 1000 || 0;
  }

  onToggle() {
    // Closed from outside (e.g. Escape key) - drop the animation state classes.
    if (!this.mainDetailsToggle.open) {
      clearTimeout(this.hideTimer);
      this.mainDetailsToggle.classList.remove('is-open', 'is-closing');
    }

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
